import React from 'react'
import { Textarea } from 'SRC/ui/FormElements'

export const Description = () =>
  <Textarea
    id='description'
    name='description'
    label='Kraći opis (max 500 karaktera)'
    maxLength={500}
    allowedCharacters={['letters', 'numbers', 'characters']}
  />
